module.exports = "data:image/svg+xml;base64,PHN2ZyBjbGFzcz0iaWNvbiIgdmlld0JveD0iMCAwIDEwMjQgMTAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB3aWR0aD0iNjQiIGhlaWdodD0iNjQiPjxkZWZzPjxzdHlsZS8+PC9kZWZzPjxwYXRoIGQ9Ik01NTQuNjY3IDM4NGgyMzQuNjY2TDU1NC42NjcgMTQ5LjMzM1YzODRNMjU2IDg1LjMzM2gzNDEuMzMzbDI1NiAyNTZ2NTEyQTg1LjMzMyA4NS4zMzMgMCAwIDEgNzY4IDkzOC42NjdIMjU2YTg1LjMzMyA4NS4zMzMgMCAwIDEtODUuMzMzLTg1LjMzNFYxNzAuNjY3QTg1LjAzOCA4NS4wMzggMCAwIDEgMjU2IDg1LjMzM002NDAgNzY4di04NS4zMzNIMjU2Vjc2OGgzODRtMTI4LTE3MC42NjdWNTEySDI1NnY4NS4zMzNoNTEyeiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/documentation.svg
// module id = zUKd
// module chunks = 72